export const tableColumnsAgent = [
  {
    id: "uf",
    label: "UF",
  },
  {
    id: "nome",
    label: "Nome",
  },
  {
    id: "totalAtendimentos",
    label: "Qtde",
  },
  {
    id: "mediaDiaria",
    label: "Média diária",
  },
  {
    id: "porcentagem",
    label: "Conversão App",
  },
  {
    id: "recorrencia",
    label: "Recorrência",
  },
];
